/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { devLog } from "@/utils/devLog";

/**
 * Synchronise les métadonnées MediaSession (titre, artiste, pochette, état)
 * avec la radio en cours. Affichées sur lockscreen iOS/Android et CarPlay.
 *
 * Notes iOS Safari (17/18) :
 * - Sans setPositionState, iOS n'affiche pas les contrôles MediaSession
 *   pour les flux live (duration=Infinity). On force duration=0 finie.
 * - Le type d'artwork est ajusté selon l'extension de l'URL (png vs jpg)
 *   car iOS rejette le mauvais MIME.
 */
const _pickType = (url) => {
  const u = (url || "").toLowerCase();
  if (u.endsWith(".jpg") || u.endsWith(".jpeg")) return "image/jpeg";
  if (u.endsWith(".webp")) return "image/webp";
  return "image/png";
};

export function useMediaSessionMetadata({ currentId, radios, metaMap, isPlaying }) {
  useEffect(() => {
    if (!("mediaSession" in navigator)) return;
    const radio = radios.find((r) => r.id === currentId);
    if (!radio) return;

    const meta = metaMap[currentId];
    const cover = meta?.artwork || radio.logo;
    const title = meta?.title || radio.name;
    const artist = meta?.artist || radio.tagline || "Live";
    const type = _pickType(cover);

    try {
      navigator.mediaSession.metadata = new window.MediaMetadata({
        title,
        artist,
        album: radio.name,
        artwork: [
          { src: cover, sizes: "96x96", type },
          { src: cover, sizes: "192x192", type },
          { src: cover, sizes: "256x256", type },
          { src: cover, sizes: "384x384", type },
          { src: cover, sizes: "512x512", type },
        ],
      });
      navigator.mediaSession.playbackState = isPlaying ? "playing" : "paused";
      // iOS exige une duration finie pour afficher les contrôles
      if (navigator.mediaSession.setPositionState) {
        navigator.mediaSession.setPositionState({
          duration: 0,
          position: 0,
          playbackRate: 1,
        });
      }
    } catch (err) {
      devLog("mediaSession metadata set failed", err);
    }
  }, [currentId, radios, metaMap, isPlaying]);
}
